"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const classes = __importStar(require("./password.module.scss"));
const PasswordSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
        core_1.minLengthValidator,
    ]);
    const [showPassword, setShowPassword] = react_1.default.useState(false);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "mb-3" },
            react_1.default.createElement(Form_1.default.Control, Object.assign({ type: showPassword ? "text" : "password", className: (0, classnames_1.default)({
                    "has-error": fieldState.invalid,
                }), value: value || "", style: { position: "relative", paddingRight: "39px" } }, registerProps)),
            react_1.default.createElement("button", { className: (0, classnames_1.default)("btn", classes.noBorder), style: Object.assign({ color: "#6c757d", cursor: "pointer", zIndex: 1000, boxShadow: "none", border: "none !important" }, { position: "absolute", right: 0 }), type: "button", onClick: () => {
                    setShowPassword((showPassword) => !showPassword);
                } },
                react_1.default.createElement("i", { className: "mdi mdi-eye" })))));
};
PasswordSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("PasswordDisplayComponent");
exports.default = PasswordSchemaComponent;
